import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-admin-browsproduct',
  templateUrl: './admin-browsproduct.component.html',
  styleUrls: ['./admin-browsproduct.component.scss']
})
export class AdminBrowsproductComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
